declare global {
    interface Window { PageLoadedQueue: PageLoadedQueue; }
}

/**
 * This class create a queue for functions or javascript calls which should
 * be called if the page was loaded.
 * Use the static method `addFunction` to add a function to the queue.
 * If the page was loaded all functions will be called.
 * If the queue was called successfully and a function was added to the queue this function will be called immediately.
 */
class PageLoadedQueue {
    /**
     * Queue of functions
     */
    public static functionsQueue: any[] = [];

    /**
     * Indicates if page is loaded
     */
    public static pageLoaded: boolean = false;

    /**
     * Indicates if event listener is initialized
     */
    public static initialized: boolean = false;

    /**
     * Adds function to queue
     *
     * @param func
     */
    public static addFunction(func: any) {
        if (!this.initialized) {
            window.addEventListener('DOMContentLoaded', PageLoadedQueue.pageLoadedHandler);

            if (document.readyState !== 'loading') {
                PageLoadedQueue.pageLoadedHandler();
            }

            this.initialized = true;
        }

        // if page is already loaded, run function immediately
        if (this.pageLoaded) {
            func();
        } else {
            this.functionsQueue.push(func);
        }
    }

    /**
     * Handler for page loaded event
     *
     * @private
     */
    private static pageLoadedHandler() {
        this.pageLoaded = true;
        PageLoadedQueue.run();
    }

    /**
     * Runs all functions in queue
     */
    public static run() {
        if (this.functionsQueue && this.functionsQueue.length > 0) {
            const runScripts = this.functionsQueue;
            this.functionsQueue = []; // clear queue

            runScripts.forEach((func) => {
                func();
            });

            const pageLoadedEvent = new Event('Plandent.pageLoadedQueue.loaded');
            document.dispatchEvent(pageLoadedEvent);
        }
    }
}

export default PageLoadedQueue;
